import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import './AppsIcon.css';

export default function AppsIcon() {
  const [userApps, setUserApps] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  // All available apps (excluding CRM since we're in it)
  const allApps = [
    {
      id: 'brsr',
      name: 'BRSR Tool',
      icon: 'las la-file-alt',
      url: process.env.REACT_APP_BRSR_URL || 'http://localhost:3000',
      accessFlag: 'brsrAccess',
      color: '#4285f4',
    },
    {
      id: 'compliance',
      name: 'Compliance Tool',
      icon: 'las la-clipboard-check',
      url: process.env.REACT_APP_COMPLIANCE_URL || 'http://localhost:3004',
      accessFlag: 'complianceAccess',
      color: '#34a853',
    },
    {
      id: 'lms',
      name: 'LMS',
      icon: 'las la-graduation-cap',
      url: process.env.REACT_APP_LMS_URL || 'http://localhost:3002',
      accessFlag: 'lmsAccess',
      color: '#fbbc04',
    },
    {
      id: 'survey',
      name: 'Survey Dashboard',
      icon: 'las la-poll',
      url: process.env.REACT_APP_SURVEY_URL || 'http://localhost:3001',
      accessFlag: 'surveyAccess',
      color: '#ea4335',
    },
  ];

  useEffect(() => {
    try {
      // Read access flags from cookies
      const brsrAccess = Cookies.get('brsrAccess') === 'true';
      const complianceAccess = Cookies.get('complianceAccess') === 'true';
      const lmsAccess = Cookies.get('lmsAccess') === 'true';
      const surveyAccess = Cookies.get('surveyAccess') === 'true';

      console.log('🔍 CRM AppsIcon - Access flags:', {
        brsrAccess,
        complianceAccess,
        lmsAccess,
        surveyAccess,
      });

      // Get user role for Survey Dashboard routing
      let userRole = null;
      try {
        const userCookie = Cookies.get('user');
        if (userCookie) {
          const userData = JSON.parse(userCookie);
          userRole = userData.role;
          console.log('🔍 CRM AppsIcon - User role:', userRole);
        }
      } catch (error) {
        console.error('Error parsing user cookie:', error);
      }

      // Filter apps based on user access (exclude CRM since we're in it)
      const accessibleApps = allApps
        .filter((app) => {
          if (app.accessFlag === 'brsrAccess') return brsrAccess;
          if (app.accessFlag === 'complianceAccess') return complianceAccess;
          if (app.accessFlag === 'lmsAccess') return lmsAccess;
          if (app.accessFlag === 'surveyAccess') return surveyAccess;
          return false;
        })
        .map((app) => {
          // Special handling for Survey Dashboard - role-based routing
          if (app.id === 'survey' && userRole) {
            const isSuperAdmin = 
              userRole === 'SUPER_ADMIN' || 
              userRole === 'SUPERADMIN' ||
              (typeof userRole === 'object' && userRole !== null && 
                (userRole.name === 'SUPER_ADMIN' || 
                 userRole.name === 'SUPERADMIN' || 
                 userRole.accessLevel === 'SUPER_ADMIN'));
            
            // SUPER_ADMIN → root, USER → /user
            return {
              ...app,
              url: isSuperAdmin 
                ? (process.env.REACT_APP_SURVEY_URL || 'http://localhost:3001')
                : (process.env.REACT_APP_SURVEY_URL || 'http://localhost:3001') + '/user'
            };
          }
          return app;
        });

      console.log('🔍 CRM AppsIcon - Accessible apps:', accessibleApps);
      setUserApps(accessibleApps);
    } catch (error) {
      console.error('Error checking user access:', error);
    }
  }, []);

  const handleAppClick = (app) => {
    console.log('🚀 Navigating to:', app.name, app.url);
    window.open(app.url, '_blank');
    setIsOpen(false);
  };

  const togglePopover = () => {
    setIsOpen(!isOpen);
  };

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest('.apps-icon-container')) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  return (
    <div className="apps-icon-container">
      <button 
        onClick={togglePopover}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '40px',
          height: '40px',
          border: 'none',
          borderRadius: '50%',
          background: 'transparent',
          cursor: 'pointer',
          transition: 'background-color 0.2s',
          padding: 0
        }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.05)'}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
      >
        <i className="las la-th" style={{ fontSize: '20px' }} />
      </button>

      {isOpen && (
        <div 
          style={{ 
            position: 'absolute',
            top: 'calc(100% + 8px)',
            right: 0,
            backgroundColor: '#ffffff',
            background: '#ffffff',
            borderRadius: '12px',
            boxShadow: '0 4px 16px rgba(0, 0, 0, 0.15)',
            width: '312px',
            zIndex: 10000,
            color: '#000000'
          }}
        >
          <div 
            style={{ 
              padding: '16px 20px 12px',
              borderBottom: '1px solid #e8eaed',
              backgroundColor: '#ffffff',
              background: '#ffffff',
              color: '#202124'
            }}
          >
            <h4 style={{ margin: 0, fontSize: '14px', fontWeight: 500, color: '#202124' }}>
              ESGfit Apps
            </h4>
          </div>
          <div 
            style={{ 
              padding: '16px',
              backgroundColor: '#ffffff',
              background: '#ffffff'
            }}
          >
            {userApps.length === 0 ? (
              <div style={{ padding: '32px 16px', textAlign: 'center' }}>
                <p style={{ margin: 0, fontSize: '14px', color: '#5f6368' }}>
                  No other apps available
                </p>
              </div>
            ) : (
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(3, 1fr)', 
                gap: '8px' 
              }}>
                {userApps.map((app) => (
                  <button
                    key={app.id}
                    onClick={() => handleAppClick(app)}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '12px 8px',
                      border: 'none',
                      borderRadius: '8px',
                      background: 'transparent',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(95, 99, 104, 0.08)'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                  >
                    <div style={{
                      width: '48px',
                      height: '48px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '50%',
                      marginBottom: '8px'
                    }}>
                      <i className={app.icon} style={{ fontSize: '28px', color: app.color }} />
                    </div>
                    <div style={{
                      fontSize: '12px',
                      color: '#202124',
                      fontWeight: 400,
                      textAlign: 'center',
                      lineHeight: '16px',
                      maxWidth: '100%',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical'
                    }}>
                      {app.name}
                    </div>
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

